import { Component, Input, Output, EventEmitter, ViewChild, ViewContainerRef, ComponentRef, Type, OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, HostListener, ElementRef, inject, ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { gsap } from 'gsap';
import { assertValidResizablePanelWidths } from '../../utils/resizable-panel-validation.util';

@Component({
  selector: 'app-resizable-panel',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="resizable-panel-overlay"
      (click)="onOverlayClick($event)">

      <div
        class="resizable-panel"
        [style.width.%]="currentWidthPercent"
        (click)="$event.stopPropagation()">

        <!-- Drag Handle -->
        <div
          class="drag-handle"
          [class.at-max-width]="isAtMaxWidth()"
          [class.at-min-width]="isAtMinWidth()"
          [class.between-min-max]="isBetweenMinMax()"
          (mousedown)="startDrag($event)"
          (touchstart)="startDrag($event)">
          <div class="drag-indicator">
          </div>
        </div>

        <!-- Content Container with Header -->
        <div
          class="panel-content-wrapper"
          [class.mobile-header-enabled]="showMobileHeader"
          [class.desktop-header-enabled]="showDesktopHeader"
          [class.mobile-sheet-enabled]="showMobileSheetStyle"
        >
          <!-- Mobile Header (Quick Options style) -->
          <div
            class="panel-mobile-header"
            *ngIf="showMobileHeaderActive"
          >
            <button
              type="button"
              class="mobile-back-btn"
              (click)="requestClose()"
              aria-label="Back"
              title="Back"
            >
              <img [src]="mobileHeaderBackIconSrc" alt="Back" class="mobile-back-icon" />
            </button>
            <div class="mobile-header-title">{{ getMobileHeaderTitle() }}</div>
          </div>

          <!-- Sticky Header (Desktop) -->
          <div class="panel-header" *ngIf="showDesktopHeader">
            <h2 class="panel-title">{{ getDesktopHeaderTitle() }}</h2>
            <div class="panel-header-actions">
              <button
                *ngIf="showInfoButton"
                class="panel-info-btn"
                [class.active]="infoButtonActive"
                (click)="infoButtonClick.emit()"
                aria-label="Info"
                title="Agent History"
              >
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.35778 2.34918C5.52028 -0.809149 10.6619 -0.775815 13.8436 2.40668C17.027 5.59002 17.0603 10.7342 13.897 13.8967C10.7336 17.0592 5.59028 17.0267 2.40695 13.8434C1.51143 12.9517 0.834811 11.8646 0.430244 10.6674C0.0256778 9.47015 -0.0958236 8.19544 0.0752829 6.94335C0.0977158 6.77903 0.184507 6.63035 0.316564 6.53001C0.448621 6.42968 0.615126 6.38592 0.77945 6.40835C0.943773 6.43078 1.09246 6.51758 1.19279 6.64963C1.29312 6.78169 1.33688 6.94819 1.31445 7.11252C1.16919 8.17361 1.27202 9.25394 1.61485 10.2686C1.95769 11.2832 2.5312 12.2045 3.29028 12.96C5.99445 15.6634 10.3469 15.6792 13.0136 13.0134C15.6795 10.3467 15.6636 5.99418 12.9603 3.29002C10.2578 0.588351 5.90778 0.570851 3.24112 3.23335L3.86445 3.23585C3.94653 3.23623 4.02772 3.25278 4.1034 3.28454C4.17909 3.31631 4.24777 3.36266 4.30554 3.42097C4.3633 3.47928 4.40902 3.54839 4.44007 3.62437C4.47113 3.70034 4.48692 3.78169 4.48653 3.86377C4.48615 3.94584 4.4696 4.02704 4.43784 4.10272C4.40608 4.1784 4.35972 4.24709 4.30141 4.30486C4.2431 4.36262 4.17399 4.40834 4.09802 4.43939C4.02204 4.47045 3.94069 4.48623 3.85862 4.48585L1.73695 4.47585C1.5722 4.47497 1.41446 4.40908 1.29804 4.29251C1.18162 4.17593 1.11594 4.0181 1.11528 3.85335L1.10445 1.73335C1.10401 1.65127 1.11974 1.56992 1.15075 1.49392C1.18175 1.41792 1.22742 1.34878 1.28515 1.29043C1.34288 1.23209 1.41153 1.18568 1.48719 1.15387C1.56285 1.12206 1.64404 1.10546 1.72612 1.10502C1.80819 1.10458 1.88955 1.12031 1.96555 1.15132C2.04154 1.18232 2.11069 1.22799 2.16903 1.28572C2.22738 1.34345 2.27379 1.4121 2.3056 1.48776C2.33741 1.56342 2.35401 1.64461 2.35445 1.72668L2.35778 2.34918ZM8.12445 4.16585C8.29021 4.16585 8.44918 4.2317 8.56639 4.34891C8.6836 4.46612 8.74945 4.62509 8.74945 4.79085V7.86585L10.6503 9.76585C10.71 9.82348 10.7576 9.89242 10.7904 9.96866C10.8232 10.0449 10.8405 10.1269 10.8413 10.2099C10.842 10.2929 10.8263 10.3752 10.7949 10.452C10.7635 10.5288 10.7171 10.5986 10.6584 10.6573C10.5998 10.7161 10.53 10.7625 10.4532 10.794C10.3764 10.8254 10.2942 10.8413 10.2112 10.8406C10.1282 10.8399 10.0462 10.8227 9.96989 10.79C9.89362 10.7573 9.82463 10.7097 9.76695 10.65L7.50028 8.38335V4.79168C7.50028 4.62592 7.56613 4.46695 7.68334 4.34974C7.80055 4.23253 7.95952 4.16668 8.12528 4.16668" fill="currentColor"/>
                </svg>
              </button>
              <button class="panel-close-btn" (click)="requestClose()" aria-label="Close" title="Close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 17L17 12L12 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M7 7L12 12L7 17" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </div>
          </div>

          <!-- Content -->
          <div class="panel-content">
            <!-- For projected content -->
            <ng-content></ng-content>
            <!-- For dynamic components -->
            <ng-container #dynamicComponentContainer></ng-container>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .resizable-panel-overlay {
      position: fixed;
      /* Use inset:0 so all four edges are anchored to the viewport.
         On iOS Safari, top/right/bottom/left:0 + position:fixed tracks the
         VISUAL viewport (not the layout viewport), which is what we want. */
      inset: 0;
      width: 100%;
      /* 100dvh = dynamic viewport height — updates as iOS Safari's toolbar
         appears/disappears. Falls back to 100vh on older browsers. */
      height: 100dvh;
      /* fallback for browsers without dvh support (iOS < 15.4) */
      /* stylelint-disable-next-line declaration-block-no-duplicate-properties */
      height: 100vh;
      height: 100dvh;
      background-color: rgba(0, 0, 0, 0.3);
      /* z-index must beat: CDK overlay (10000), profile-card (10001),
         any Angular Material/PrimeNG dialog. Set to 100000 as CSS baseline;
         the JS portal sets 2000000 via inline !important for iOS. */
      z-index: 100000;
      isolation: isolate;
    }

    .resizable-panel {
      position: absolute;
      top: 0;
      right: 0;
      /* Match overlay height — dvh tracks the visual viewport on iOS */
      height: 100vh;
      height: 100dvh;
      background: white;
      box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
      display: flex;
      min-width: 40vw;
      max-width: 95vw;
      transform: translateX(100%);
      z-index: 100001;
    }

    .drag-handle {
      height: 100%;
      background: transaparent;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      transition: background-color 0.2s ease;
      flex-shrink: 0;
      padding: 0 0.2px;
    }

    .drag-handle::before {
      content: '';
      position: absolute;
      top: 0;
      left: -20px;
      right: -20px;
      height: 100%;
      cursor: inherit;
    }

    /* Dynamic cursor based on width constraints */
    .drag-handle.at-max-width {
      cursor: url('/assets/icons/Resize - Min.svg') 14 14, w-resize !important;
    }

    .drag-handle.at-min-width {
      cursor: url('/assets/icons/Resize - Max.svg') 14 14, w-resize !important;
    }

    .drag-handle.between-min-max {
     cursor: url('/assets/icons/Resize - Middle.svg') 14 14, w-resize !important;
    }

    .drag-handle:hover {
      background: #e8e8e8;
    }

    .drag-handle:active {
      background: #d0d0d0;
    }

    .drag-indicator {
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 1s ease;
      color: #333;
    }

    .drag-handle:hover .drag-indicator {
      opacity: 1;
    }

    .drag-line {
      background: #999;
      border-radius: 1px;
    }

    .panel-content-wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
      min-height: 0; /* Safari/iOS: allow flex children to shrink */
      /* iOS safe area support */
      padding-top: env(safe-area-inset-top, 0px);
    }

    /* On mobile: hide component-provided headers since the panel renders its own mobile header */
    @media (max-width: 768px) {
      :host ::ng-deep .panel-content-wrapper.mobile-header-enabled .panel-content .panel-inner-header,
      :host ::ng-deep .panel-content-wrapper.mobile-header-enabled .panel-content .panel-header {
        display: none !important;
      }
    }

    /* On desktop: hide component-provided headers when the panel renders its own desktop header */
    :host ::ng-deep .panel-content-wrapper.desktop-header-enabled .panel-content .panel-inner-header,
    :host ::ng-deep .panel-content-wrapper.desktop-header-enabled .panel-content .panel-header {
      display: none !important;
    }

    .panel-mobile-header {
      display: none;
      align-items: center;
      justify-content: center;
      padding: 16px 20px;
      padding-top: calc(16px + env(safe-area-inset-top, 0px));
      background: #ffffff;
      position: relative;
      z-index: 2000;
      flex-shrink: 0;
      min-height: 64px;
    }

    .mobile-back-btn {
      width: 40px;
      height: 40px;
      border: none;
      background: #292929;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      cursor: pointer;
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .mobile-back-icon {
      width: 15px;
      height: 15px;
      display: block;
    }

    .mobile-header-title {
      flex: 1;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: var(--colors-text-primary, #111827);
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* Define CSS Custom Properties for dark mode inheritance */
    :host-context([data-theme='dark']) .resizable-panel,
    :host-context(html.dark) .resizable-panel {
      // CSS Variables that children can inherit
      --panel-header-bg: #1E1E1E;
      --panel-body-bg: #1A1A1A;
      --panel-text-primary: #e5e5e5;
      --panel-text-secondary: #d4d4d4;
      --panel-border-color: #404040;
      --panel-card-bg: #1E1E1E;
    }

    /* Sticky Header Styles */
    .panel-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px;
      border-bottom: 1px solid #0000001F;
      background: #ffffff;
      position: sticky;
      top: 0;
      z-index: 10;
      flex-shrink: 0;
    }

    .panel-header-actions {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .panel-info-btn {
      padding: 0.5rem;
      background: none;
      border: none;
      border-radius: 0.375rem;
      cursor: pointer;
      color: #404040;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
    }

    .panel-info-btn:hover,
    .panel-info-btn.active {
      background: #f3f4f6;
      color: #111827;
    }

    /* Dark Mode Support - Panel Header and Body */
    :host-context([data-theme='dark']),
    :host-context(html.dark) {
      .panel-mobile-header {
        background: #1E1E1E !important;
        border-bottom: 1px solid #404040;
      }

      .mobile-header-title {
        color: #e5e5e5 !important;
      }

      .panel-header {
        background: #1E1E1E !important;
        border-bottom-color: #404040;
      }

      .panel-title {
        color: #e5e5e5;
      }

      .panel-close-btn {
        color: #e5e5e5;

        svg path {
          stroke: #e5e5e5;
        }

        &:hover {
          background: #333333;
        }

        &:active {
          background: #404040;
        }
      }

      .panel-info-btn {
        color: #e5e5e5;

        &:hover,
        &.active {
          background: #333333;
          color: #ffffff;
        }
      }

      .panel-content {
        background: #1A1A1A !important;
      }

      .resizable-panel {
        background: #1A1A1A !important;
      }

      .drag-handle {
        &:hover {
          background: #333333;
        }

        &:active {
          background: #404040;
        }
      }
    }

    .panel-title {
      font-size: 16px;
      font-weight: 500;
      color: #1f2937;
      margin: 0;
    }

    .panel-close-btn {
      padding: 0.5rem;
      background: none;
      border-radius: 0.375rem;
      cursor: pointer;
      color: #404040;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s;
    }

    .panel-close-btn:hover {
      background: #f3f4f6;
      border-color: #e5e7eb;
    }

    .panel-close-btn:active {
      background: #e5e7eb;
    }

    .panel-close-btn svg {
      display: block;
    }

    .panel-content {
      flex: 1;
      overflow-y: auto;
      min-height: 0; /* Safari/iOS: prevent unintended outer scrolling */
      display: flex;
      flex-direction: column;
    }

    /* Allow child components to fill the panel content and handle their own scrolling */
    /* ::ng-deep is required to penetrate Angular view encapsulation and reach the child component host element */
    :host ::ng-deep .panel-content > * {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    /* Responsive behavior */
    @media (max-width: 768px) {
      .resizable-panel {
        min-width: 280px;
        width: 100% !important;
        max-width: 100% !important;
      }

      .panel-mobile-header {
        display: flex;
        padding-top: max(16px, env(safe-area-inset-top, 16px));
      }

      /* Safe-area padding is handled by the mobile header */
      .panel-content-wrapper.mobile-header-enabled {
        padding-top: 0;
      }

      /* Mobile modal body styling (Settings sheet style) */
      .panel-content-wrapper.mobile-sheet-enabled .panel-content {
        background: #f0f4f5;
        padding: 22px;
        border-radius: 40px 40px 0 0;
      }

      /* Footer bars: make common "border-t p-4 flex" footers full-width on mobile */
      :host ::ng-deep .panel-content-wrapper.mobile-sheet-enabled .panel-content .border-t.p-4.flex {
        margin: 0 -22px -22px;
        padding: 16px 22px calc(16px + env(safe-area-inset-bottom, 0px));
        border-top: none !important;
      }

      /* When using mobile header, hide the default panel header on mobile */
      .panel-content-wrapper.mobile-header-enabled .panel-header {
        display: none;
      }
    }

    @media (max-width: 480px) {
      .resizable-panel {
        width: 100% !important;
        min-width: 100%;
      }
      
      .drag-handle {
        display: none;
      }
    }

    /* Prevent text selection during drag */
    .dragging {
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
    }
  `]
})
export class ResizablePanelComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() isVisible: boolean = false;
  @Input() title: string = '';
  @Input() componentName?: string; // Optional: Name of the component using this panel (for better error messages)

  /** Mobile-only header (Quick Options style) */
  @Input() enableMobileHeader: boolean = false;
  @Input() mobileHeaderTitle: string = '';
  @Input() mobileHeaderBackIconSrc: string = 'assets/images/back-btn.png';

  /**
   * Mobile-only "sheet" body styling (used in Settings modals).
   * Keeps desktop unchanged and makes footer buttons sit on a white area.
   */
  @Input() enableMobileSheetStyle: boolean = false;

  /**
   * Forces app header behind the panel on mobile while this panel is open.
   * Use this for screens where iOS stacking contexts can place the header above
   * the panel content.
   */
  @Input() adjustHeaderLayerOnMobile: boolean = false;

  /**
   * When true, moves the overlay element to document.body on open to escape
   * ancestor overflow/clip contexts (e.g. overflow:hidden + border-radius).
   * Moves it back to the host element on close.
   */
  @Input() useBodyPortal: boolean = false;

  /**
   * Optional body class applied while the panel is visible.
   * Useful for global UI overrides that must track the panel state exactly.
   */
  @Input() bodyClassWhileOpen: string = '';

  private _defaultWidthPercent: number = 40;
  private _minWidthPercent: number = 40;
  private _maxWidthPercent: number = 95;

  @Input()
  set defaultWidthPercent(value: number) {
    this._defaultWidthPercent = value;
  }
  get defaultWidthPercent(): number {
    return this._defaultWidthPercent;
  }

  @Input()
  set minWidthPercent(value: number) {
    this._minWidthPercent = value;
  }
  get minWidthPercent(): number {
    return this._minWidthPercent;
  }

  @Input()
  set maxWidthPercent(value: number) {
    this._maxWidthPercent = value;
  }
  get maxWidthPercent(): number {
    return this._maxWidthPercent;
  }

  @Input() component: Type<any> | null = null;
  @Input() componentInputs: any = {};
  @Input() showInfoButton: boolean = false;
  @Input() infoButtonActive: boolean = false;

  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() visibilityChange = new EventEmitter<boolean>();
  @Output() widthChange = new EventEmitter<number>();
  @Output() componentReady = new EventEmitter<ComponentRef<any>>();
  @Output() panelClosed = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();
  @Output() infoButtonClick = new EventEmitter<void>();

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef })
  dynamicComponentContainer!: ViewContainerRef;

  private elementRef = inject(ElementRef);
  private cdr = inject(ChangeDetectorRef);
  private ngZone = inject(NgZone);

  currentWidthPercent: number = 40;
  private isDragging: boolean = false;
  private wasRecentlyDragging: boolean = false;
  private startX: number = 0;
  private startWidth: number = 0;
  private componentRef: ComponentRef<any> | null = null;
  private animationFrameId: number | null = null;
  private overlayElement: HTMLElement | null = null;
  private panelElement: HTMLElement | null = null;
  private isPortaledToBody: boolean = false;
  isAnimating: boolean = false;
  private validationChecked: boolean = false;
  private settingsHeaderLayerApplied = false;
  private mobileHeaderHiddenApplied = false;
  /** Stores per-element style overrides applied by iosNeutralizeGpuLayers() so they can be reverted on close. */
  private _iosGpuLayerOriginals: Array<{ el: HTMLElement; props: Record<string, string> }> = [];

  get showMobileHeader(): boolean {
    return this.enableMobileHeader === true;
  }

  get showMobileHeaderActive(): boolean {
    return this.showMobileHeader;
  }

  get showDesktopHeader(): boolean {
    // Only show the panel's own desktop header when an explicit title is provided.
    // When enableMobileHeader is used, the component provides its own panel-inner-header for desktop.
    return !this.isMobileViewport && this.title?.trim().length > 0;
  }

  get showMobileSheetStyle(): boolean {
    return this.enableMobileSheetStyle === true;
  }

  private isMobileViewport: boolean = false;

  private updateViewportFlags(): void {
    if (typeof window === 'undefined') return;
    this.isMobileViewport = window.innerWidth <= 768;
  }

  getMobileHeaderTitle(): string {
    if (this.mobileHeaderTitle && this.mobileHeaderTitle.trim().length > 0) {
      return this.mobileHeaderTitle;
    }

    if (this.title && this.title.trim().length > 0) {
      return this.title;
    }

    // Fallback to component class name for a reasonable default
    const name = this.component?.name || this.componentName || 'Details';
    return name.replace(/Component$/, '').replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  getDesktopHeaderTitle(): string {
    if (this.title && this.title.trim().length > 0) {
      return this.title;
    }
    return this.getMobileHeaderTitle();
  }

  /**
   * Validates the width configuration
   * This is called in ngOnInit after all inputs have been set
   * and will throw an error immediately, causing the application to fail to initialize
   */
  private validateWidthConfiguration(): void {
    // Skip validation if already checked
    if (this.validationChecked) {
      return;
    }

    // Use provided component name or try to detect it from the stack
    const callingComponent = this.componentName || this.getCallingComponentName();

    // Perform validation - this will throw an error if invalid
    assertValidResizablePanelWidths(
      {
        defaultWidthPercent: this._defaultWidthPercent,
        minWidthPercent: this._minWidthPercent,
        maxWidthPercent: this._maxWidthPercent
      },
      callingComponent
    );

    // Only mark as validated if validation passed
    this.validationChecked = true;
  }

  /**
   * Attempts to detect the calling component name from the error stack trace
   * Note: This only works in development builds. In production, component names are minified.
   */
  private getCallingComponentName(): string {
    // In production builds, component names are minified and not available in stack traces
    // Return a message indicating the component name could not be detected
    return 'Check the browser console for the full error location';
  }

  ngOnInit() {
    // CRITICAL: Validate configuration before initializing
    // This ensures the component cannot be used with invalid configuration
    this.validateWidthConfiguration();

    this.currentWidthPercent = this.defaultWidthPercent;
    this.updateViewportFlags();
  }

  ngOnDestroy() {
    this.setBodyClassWhileOpen(false);
    this.returnOverlayFromBody();
    this.removeSettingsHeaderLayerIfNeeded();
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  ngAfterViewInit() {
    // Cache DOM elements for GSAP animations
    this.overlayElement = this.elementRef.nativeElement.querySelector('.resizable-panel-overlay');
    this.panelElement = this.elementRef.nativeElement.querySelector('.resizable-panel');

    // Initialize elements with autoAlpha: 0 and position off-screen
    if (this.overlayElement && this.panelElement) {
      // Always start hidden, then animate in if visible
      gsap.set(this.overlayElement, { autoAlpha: 0 });
      gsap.set(this.panelElement, { autoAlpha: 0, x: '100%' });

      // If visible on mount, animate in
      if (this.isVisible) {
        this.applySettingsHeaderLayerIfNeeded();
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          this.animateOpen();
        }, 50);
      }
    }

    if (this.component && this.isVisible) {
      this.loadComponent();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Only react to actual changes, not initial values
    const isVisibleChanged = changes['isVisible'] && !changes['isVisible'].firstChange;
    const componentChanged = changes['component'] && !changes['component'].firstChange;
    const componentInputsChanged = changes['componentInputs'];

    // Handle visibility changes
    if (isVisibleChanged) {
      if (this.isVisible) {
        this.setBodyClassWhileOpen(true);
        this.applySettingsHeaderLayerIfNeeded();
        // Panel is opening - RESET all GSAP states to ensure clean animation
        if (this.overlayElement && this.panelElement) {
          // Kill any ongoing animations first
          gsap.killTweensOf([this.overlayElement, this.panelElement]);

          // Reset to initial hidden state
          gsap.set(this.overlayElement, { autoAlpha: 0 });
          gsap.set(this.panelElement, { autoAlpha: 0, x: '100%' });

          // Reset width to default
          this.currentWidthPercent = this.defaultWidthPercent;

          // Now animate open
          this.animateOpen();
        }
        if (this.component && this.dynamicComponentContainer) {
          this.loadComponent();
        } else if (this.component) {
          // ViewChild may not be resolved yet — ensure change detection runs,
          // then retry on the next microtask once the view is updated.
          this.cdr.detectChanges();
          Promise.resolve().then(() => {
            if (this.isVisible && this.component && this.dynamicComponentContainer) {
              this.loadComponent();
            }
          });
        }
      } else {
        this.setBodyClassWhileOpen(false);
        this.removeSettingsHeaderLayerIfNeeded();
        // Panel is closing - only schedule cleanup if not already animating
        // (close() method handles animation and cleanup when user initiates close)
        if (!this.isAnimating && this.overlayElement && this.panelElement) {
          // Parent programmatically closed - animate out
          this.animateClose();
          setTimeout(() => {
            this.cleanupComponent();
          }, 650);
        } else if (!this.isAnimating) {
          // No animation needed, cleanup immediately
          this.cleanupComponent();
        }
      }
    }

    // Handle component changes (when switching between different components)
    if (componentChanged && this.isVisible && this.dynamicComponentContainer) {
      this.loadComponent();
    }

    // Handle component inputs changes (update existing component instance)
    if (componentInputsChanged && !componentInputsChanged.firstChange && this.componentRef) {
      const prev = componentInputsChanged.previousValue;
      const curr = componentInputsChanged.currentValue;

      // Shallow comparison to avoid redundant setInput calls and prevent infinite change detection loops
      let inputsHaveChanged = false;
      if (!prev || !curr) {
        inputsHaveChanged = true;
      } else {
        const prevKeys = Object.keys(prev);
        const currKeys = Object.keys(curr);
        if (prevKeys.length !== currKeys.length) {
          inputsHaveChanged = true;
        } else {
          for (const key of currKeys) {
            const valPrev = prev[key];
            const valCurr = curr[key];
            if (typeof valCurr === 'object' && valCurr !== null && typeof valPrev === 'object' && valPrev !== null) {
              // Shallow compare nested object keys and values (e.g., componentData)
              const keysPrevObj = Object.keys(valPrev);
              const keysCurrObj = Object.keys(valCurr);
              if (keysPrevObj.length !== keysCurrObj.length) {
                inputsHaveChanged = true;
                break;
              }
              for (const k of keysCurrObj) {
                if (valCurr[k] !== valPrev[k]) {
                  inputsHaveChanged = true;
                  break;
                }
              }
              if (inputsHaveChanged) break;
            } else if (valCurr !== valPrev) {
              inputsHaveChanged = true;
              break;
            }
          }
        }
      }

      if (!inputsHaveChanged) {
        return;
      }

      // Update inputs on existing component instance.
      // Use setInput() so Angular triggers ngOnChanges on the child component,
      // enabling it to react to visibility/permission changes at runtime.
      if (this.componentInputs) {
        Object.keys(this.componentInputs).forEach(key => {
          if (this.componentRef) {
            try {
              // setInput() triggers ngOnChanges on the dynamic component.
              this.componentRef.setInput(key, this.componentInputs[key]);
            } catch {
              // Fallback for properties not declared as @Input().
              if (this.componentRef.instance) {
                this.componentRef.instance[key] = this.componentInputs[key];
              }
            }
          }
        });
        // Trigger change detection on the component instance
        if (this.componentRef?.changeDetectorRef) {
          this.componentRef.changeDetectorRef.detectChanges();
        }
      }
    }
  }

  private cleanupComponent() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    if (this.dynamicComponentContainer) {
      this.dynamicComponentContainer.clear();
    }
  }
  public refreshComponent() {
    this.loadComponent();
  }

  private loadComponent() {
    if (!this.dynamicComponentContainer || !this.component || !this.isVisible) return;

    // Clear existing component
    this.dynamicComponentContainer.clear();
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }

    // Create new component
    this.componentRef = this.dynamicComponentContainer.createComponent(this.component);

    // Set inputs — use setInput() so Angular triggers ngOnChanges on the
    // dynamic component (e.g. CustomerMoreInfoComponent re-runs initializeAvailableTabs).
    if (this.componentInputs) {
      console.log('ResizablePanelComponent: Setting component inputs:', this.componentInputs);
      Object.keys(this.componentInputs).forEach(key => {
        console.log(`ResizablePanelComponent: Setting ${key} =`, this.componentInputs[key]);
        if (this.componentRef) {
          try {
            this.componentRef.setInput(key, this.componentInputs[key]);
          } catch {
            // Fallback for non-@Input() properties.
            if (this.componentRef.instance) {
              this.componentRef.instance[key] = this.componentInputs[key];
            }
          }
        }
      });
      console.log('ResizablePanelComponent: Final component instance:', this.componentRef?.instance);
    }

    // Trigger change detection on the component instance
    if (this.componentRef?.changeDetectorRef) {
      this.componentRef.changeDetectorRef.detectChanges();
    }

    // Debug: log when component is created and componentReady is emitted
    console.log('ResizablePanelComponent: component created', this.componentRef?.instance?.constructor?.name);
    // Emit component ready event
    this.componentReady.emit(this.componentRef);

    // Listen for closeClicked event from dynamic child, if it exists
    if (
      this.componentRef &&
      this.componentRef.instance &&
      this.componentRef.instance.closeClicked &&
      typeof this.componentRef.instance.closeClicked.subscribe === 'function'
    ) {
      this.componentRef.instance.closeClicked.subscribe(() => {
        // Close the panel when the dynamic child requests it
        this.requestClose();
        // Also emit for any parent listeners
        this.closeClicked.emit();
      });
    }

    // Ensure the panel view reflects the newly loaded component
    this.cdr.detectChanges();
  }

  startDrag(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    event.stopPropagation(); // Prevent parent container interference
    this.isDragging = true;

    const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    this.startX = clientX;
    this.startWidth = this.currentWidthPercent;

    document.body.classList.add('dragging');
    // Disable pointer events on potential interfering elements
    document.body.style.pointerEvents = 'none';
    // Re-enable pointer events only on the panel
    const panel = this.elementRef.nativeElement.querySelector('.resizable-panel');
    if (panel) {
      (panel as HTMLElement).style.pointerEvents = 'auto';
    }

    // Add global event listeners with passive: false for better performance
    document.addEventListener('mousemove', this.onDrag, { passive: false });
    document.addEventListener('mouseup', this.stopDrag);
    document.addEventListener('touchmove', this.onDrag, { passive: false });
    document.addEventListener('touchend', this.stopDrag);
  }

  private onDrag = (event: MouseEvent | TouchEvent) => {
    if (!this.isDragging) return;

    event.preventDefault();
    event.stopPropagation(); // Prevent event from bubbling to parent containers

    const clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
    const deltaX = this.startX - clientX;
    const viewportWidth = window.innerWidth;
    const deltaPercent = (deltaX / viewportWidth) * 100;

    let newWidth = this.startWidth + deltaPercent;

    // Apply constraints
    newWidth = Math.max(this.minWidthPercent, Math.min(this.maxWidthPercent, newWidth));

    // Cancel previous animation frame if exists
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
    }

    // Use requestAnimationFrame for smooth updates
    this.animationFrameId = requestAnimationFrame(() => {
      // Run inside Angular zone to ensure change detection
      this.ngZone.run(() => {
        this.currentWidthPercent = newWidth;
        this.widthChange.emit(newWidth);
        // Explicitly trigger change detection
        this.cdr.detectChanges();
        this.animationFrameId = null;
      });
    });
  };

  private stopDrag = () => {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.wasRecentlyDragging = true;

    // Cancel any pending animation frame
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }

    // Reset the flag after a short delay to allow click detection
    setTimeout(() => {
      this.wasRecentlyDragging = false;
    }, 100);

    document.body.classList.remove('dragging');
    // Restore pointer events
    document.body.style.pointerEvents = '';
    const panel = this.elementRef.nativeElement.querySelector('.resizable-panel');
    if (panel) {
      (panel as HTMLElement).style.pointerEvents = '';
    }

    // Remove global event listeners
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.stopDrag);
    document.removeEventListener('touchmove', this.onDrag);
    document.removeEventListener('touchend', this.stopDrag);
  };

  onOverlayClick(_event: MouseEvent) {
    // Don't close if we were just dragging or already animating
    if (this.isDragging || this.wasRecentlyDragging || this.isAnimating) {
      return;
    }
    // Close panel when clicking on the overlay (outside the panel)
    this.requestClose();
  }

  open() {
    if (this.isAnimating) {
      return;
    }

    // Support both controlled usage (`[(isVisible)]`) and imperative usage (`panel.open()`).
    this.isVisible = true;
    this.setBodyClassWhileOpen(true);
    this.applySettingsHeaderLayerIfNeeded();
    this.isVisibleChange.emit(true);
    this.visibilityChange.emit(true);

    // Reset + animate open if DOM is ready; otherwise `ngAfterViewInit` will animate if visible.
    if (this.overlayElement && this.panelElement) {
      gsap.killTweensOf([this.overlayElement, this.panelElement]);
      gsap.set(this.overlayElement, { autoAlpha: 0 });
      gsap.set(this.panelElement, { autoAlpha: 0, x: '100%' });
      this.currentWidthPercent = this.defaultWidthPercent;
      this.animateOpen();
    }

    if (this.component) {
      setTimeout(() => this.loadComponent(), 0);
    }
  }

  close() {
    // Prevent multiple close calls
    if (this.isAnimating) {
      return;
    }

    // Support imperative usage (`panel.close()`) by syncing local visibility.
    this.isVisible = false;
    this.setBodyClassWhileOpen(false);
    this.removeSettingsHeaderLayerIfNeeded();

    // GLOBAL AUTOMATIC SOLUTION: Emit BOTH events
    // isVisibleChange - for two-way binding [(isVisible)]
    // visibilityChange - for backward compatibility (visibilityChange)
    // This way it works automatically with [(isVisible)] without any directive needed!
    this.isVisibleChange.emit(false);
    this.visibilityChange.emit(false);

    // Animate close, then emit panel closed and cleanup
    if (this.overlayElement && this.panelElement) {
      this.animateClose();
      // Wait for animation to complete before final cleanup
      setTimeout(() => {
        this.panelClosed.emit();
        this.cleanupComponent();
      }, 650); // Slightly longer than the longest animation (600ms)
    } else {
      // Fallback if elements not found
      this.panelClosed.emit();
      this.cleanupComponent();
    }
  }

  private shouldAdjustSettingsHeaderLayer(): boolean {
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;
    return window.innerWidth <= 767 && this.enableMobileSheetStyle === true;
  }

  private setBodyClassWhileOpen(isOpen: boolean): void {
    if (typeof document === 'undefined' || !this.bodyClassWhileOpen.trim()) {
      return;
    }

    if (isOpen) {
      document.body.classList.add(this.bodyClassWhileOpen);
      // Also add to <html> so CSS can target html.class (needed for iOS Safari
      // transition:transform fix — see styles.scss html.more-info-panel-open rule)
      document.documentElement.classList.add(this.bodyClassWhileOpen);
    } else {
      document.body.classList.remove(this.bodyClassWhileOpen);
      document.documentElement.classList.remove(this.bodyClassWhileOpen);
    }
  }

  private shouldHideHeaderOnMobile(): boolean {
    if (typeof window === 'undefined' || typeof document === 'undefined') return false;
    return window.innerWidth <= 767 && this.adjustHeaderLayerOnMobile === true;
  }

  private applySettingsHeaderLayerIfNeeded(): void {
    if (this.shouldAdjustSettingsHeaderLayer() && !this.settingsHeaderLayerApplied) {
      const body = document.body;
      const currentCount = Number(body.dataset['settingsModalOpenCount'] || '0');
      const nextCount = currentCount + 1;
      body.dataset['settingsModalOpenCount'] = String(nextCount);
      body.classList.add('settings-modal-open');
      this.setHeaderContainerZIndex('-1');
      this.settingsHeaderLayerApplied = true;
    }

    if (this.shouldHideHeaderOnMobile() && !this.mobileHeaderHiddenApplied) {
      const body = document.body;
      const currentCount = Number(body.dataset['mobileHeaderHiddenCount'] || '0');
      const nextCount = currentCount + 1;
      body.dataset['mobileHeaderHiddenCount'] = String(nextCount);
      body.classList.add('mobile-resizable-panel-open');
      this.setHeaderContainerDisplay('none');
      this.mobileHeaderHiddenApplied = true;
    }
  }

  private removeSettingsHeaderLayerIfNeeded(): void {
    if (typeof document === 'undefined') return;

    if (this.settingsHeaderLayerApplied) {
      const body = document.body;
      const currentCount = Number(body.dataset['settingsModalOpenCount'] || '1');
      const nextCount = Math.max(currentCount - 1, 0);

      if (nextCount === 0) {
        delete body.dataset['settingsModalOpenCount'];
        body.classList.remove('settings-modal-open');
        this.setHeaderContainerZIndex('0');
      } else {
        body.dataset['settingsModalOpenCount'] = String(nextCount);
      }

      this.settingsHeaderLayerApplied = false;
    }

    if (this.mobileHeaderHiddenApplied) {
      const body = document.body;
      const currentCount = Number(body.dataset['mobileHeaderHiddenCount'] || '1');
      const nextCount = Math.max(currentCount - 1, 0);

      if (nextCount === 0) {
        delete body.dataset['mobileHeaderHiddenCount'];
        body.classList.remove('mobile-resizable-panel-open');
        this.setHeaderContainerDisplay('');
      } else {
        body.dataset['mobileHeaderHiddenCount'] = String(nextCount);
      }

      this.mobileHeaderHiddenApplied = false;
    }
  }

  private setHeaderContainerZIndex(value: string): void {
    if (typeof document === 'undefined') return;
    const headers = document.querySelectorAll<HTMLElement>('.header-container');
    headers.forEach((header) => {
      header.style.setProperty('z-index', value, 'important');
    });
  }

  private setHeaderContainerDisplay(value: string): void {
    if (typeof document === 'undefined') return;
    const headers = document.querySelectorAll<HTMLElement>('.header-container');
    headers.forEach((header) => {
      if (value) {
        header.style.setProperty('display', value, 'important');
      } else {
        header.style.removeProperty('display');
      }
    });
  }

  setWidth(widthPercent: number) {
    const constrainedWidth = Math.max(
      this.minWidthPercent,
      Math.min(this.maxWidthPercent, widthPercent)
    );
    this.currentWidthPercent = constrainedWidth;
    this.widthChange.emit(constrainedWidth);
  }

  getComponentInstance<T>(): T | null {
    return this.componentRef?.instance || null;
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateViewportFlags();
    // Ensure panel doesn't exceed viewport on window resize
    const maxAllowedWidth = Math.min(this.maxWidthPercent, 95);
    if (this.currentWidthPercent > maxAllowedWidth) {
      this.setWidth(maxAllowedWidth);
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.isVisible) {
      this.requestClose();
    }
  }

  async requestClose(): Promise<void> {
    if (this.isAnimating) {
      return;
    }
    const canClose = await this.canCloseFromChild();
    if (!canClose) {
      return;
    }
    this.close();
  }

  private async canCloseFromChild(): Promise<boolean> {
    const instance: any = this.componentRef?.instance;
    if (instance && typeof instance.canClose === 'function') {
      try {
        const result = instance.canClose();
        if (result && typeof result.then === 'function') {
          return await result;
        }
        return result !== false;
      } catch (error) {
        console.warn('ResizablePanelComponent: canClose check failed, allowing close.', error);
        return true;
      }
    }
    return true;
  }

  // Methods to determine which drag indicator to show
  isAtMaxWidth(): boolean {
    // Use actual maxWidthPercent input property
    // Consider at max if within 1% of max width
    return this.currentWidthPercent >= (this.maxWidthPercent - 1);
  }

  isAtMinWidth(): boolean {
    // Use actual minWidthPercent input property
    // Consider at min if within 1% of min width
    return this.currentWidthPercent <= (this.minWidthPercent + 1);
  }

  isBetweenMinMax(): boolean {
    // Use actual input properties instead of hardcoded values
    return this.currentWidthPercent > (this.minWidthPercent + 1) &&
           this.currentWidthPercent < (this.maxWidthPercent - 1);
  }

  // GSAP animation methods
  /**
   * iOS Safari GPU compositing fix.
   * iOS paints GPU layers in CREATION ORDER, not z-index order.
   * Any element with transform/will-change/overflow-scrolling:touch creates a
   * GPU layer. If those layers were created before ours, they paint on top
   * of our portaled overlay regardless of z-index.
   *
   * Strategy:
   *  1. Demote ALL known GPU-layer sources via JS (highest specificity).
   *  2. Force a synchronous reflow — Safari re-composites here, destroying those layers.
   *  3. THEN append the overlay to body — its GPU layer is created last → paints on top.
   */
  private iosNeutralizeGpuLayers(): void {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    if (window.innerWidth > 1024) return; // desktop is not affected

    const targets: Array<{ sel: string; props: Record<string, string> }> = [
      // -webkit-overflow-scrolling:touch is iOS's #1 GPU compositing trigger.
      { sel: '.customer-dashboard-container', props: { '-webkit-overflow-scrolling': 'auto', 'overflow': 'visible' } },
      { sel: '.main-content',                 props: { '-webkit-overflow-scrolling': 'auto' } },
      // Elements with transform/will-change get promoted to GPU compositing layers.
      { sel: '.mobile-profile-card',          props: { 'transform': 'none', 'will-change': 'auto', 'z-index': '0', 'position': 'relative' } },
      { sel: 'app-mobile-tabs-navigation',    props: { 'transform': 'none', 'will-change': 'auto', 'z-index': '0' } },
      { sel: 'app-customer-profile-header',   props: { 'transform': 'none', 'will-change': 'auto', 'z-index': '0' } },
      { sel: '.desktop-dashboard-topbar',     props: { 'position': 'relative', 'z-index': '0' } },
      // overflow:hidden on ancestors creates clipping GPU layers.
      { sel: 'app-layout',                    props: { 'overflow': 'visible' } },
      { sel: 'app-customer-dashboard-layout', props: { 'overflow': 'visible' } },
      { sel: 'app-root',                      props: { 'overflow': 'visible' } },
      // Header: transition:transform promotes it to its own GPU layer.
      { sel: 'app-header',                    props: { 'transform': 'none', 'will-change': 'auto', 'z-index': '0' } },
      { sel: '.header-container',             props: { 'transform': 'none', 'will-change': 'auto', 'z-index': '0' } },
      { sel: '.dashboard-layout',             props: { 'transform': 'none', 'will-change': 'auto' } },
      { sel: '.content-container',            props: { 'transform': 'none', 'will-change': 'auto' } },
      { sel: '.sidebar-container',            props: { 'will-change': 'auto' } },
    ];

    this._iosGpuLayerOriginals = [];
    targets.forEach(({ sel, props }) => {
      document.querySelectorAll<HTMLElement>(sel).forEach(el => {
        const savedProps: Record<string, string> = {};
        Object.keys(props).forEach(prop => {
          savedProps[prop] = el.style.getPropertyValue(prop);
          el.style.setProperty(prop, props[prop], 'important');
        });
        this._iosGpuLayerOriginals.push({ el, props: savedProps });
      });
    });

    // Synchronous reflow: forces Safari to re-composite right now.
    // This demotes the above elements from GPU layers BEFORE we create the overlay layer.
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    void document.body.offsetHeight;
  }

  /** Reverts all style overrides applied by iosNeutralizeGpuLayers(). */
  private iosRestoreGpuLayers(): void {
    if (!this._iosGpuLayerOriginals.length) return;
    this._iosGpuLayerOriginals.forEach(({ el, props }) => {
      Object.keys(props).forEach(prop => {
        const original = props[prop];
        if (original) {
          el.style.setProperty(prop, original);
        } else {
          el.style.removeProperty(prop);
        }
      });
    });
    this._iosGpuLayerOriginals = [];
  }

  private animateOpen() {
    if (!this.overlayElement || !this.panelElement) return;

    this.isAnimating = true;

    // Portal overlay to document.body to escape ancestor stacking/clip contexts
    if (this.useBodyPortal && !this.isPortaledToBody) {
      // ─────────────────────────────────────────────────────────────────────────
      // iOS Safari GPU compositing fix — TIMING IS CRITICAL
      //
      // The problem:  iOS paints GPU compositing layers in CREATION ORDER, not
      //   z-index order.  Page elements (profile card, tab nav, header) already
      //   have GPU layers created at page load.  Appending our overlay later
      //   would normally create its layer AFTER theirs — but those layers were
      //   created first, so iOS paints them ON TOP regardless of z-index.
      //
      // Step 1 (synchronous): Call iosNeutralizeGpuLayers() to set
      //   transform:none !important / will-change:auto on all GPU-promoting
      //   elements via JS inline style.setProperty().  This MARKS them for
      //   GPU layer eviction.
      //
      // Step 2 (two rAF ticks): iOS GPU layer eviction is ASYNCHRONOUS.
      //   Setting CSS properties does NOT immediately evict elements from the
      //   GPU compositor — the GPU only processes those changes on the next
      //   composite frame.  We must wait at least 2 frames:
      //     • Frame 1 (layout):    browser recalculates styles, marks layers stale
      //     • Frame 2 (composite): GPU evicts the now-stale layers
      //   After 2 frames the compositor is clean — no competing GPU layers remain.
      //
      // Step 3 (after rAF): Append the overlay.  Its GPU layer is now created
      //   as the ONLY compositor layer (or at worst the LAST one), guaranteeing
      //   it paints on top of everything.
      // ─────────────────────────────────────────────────────────────────────────
      this.iosNeutralizeGpuLayers();

      const doPortalAndAnimate = () => {
        if (!this.overlayElement || !this.panelElement) return;

        document.body.appendChild(this.overlayElement);
        // Inline !important overrides any CSS that might re-add z-index on this element.
        this.overlayElement.style.setProperty('z-index', '2000000', 'important');
        // Force the overlay into its own GPU layer (translateZ(0)) so it
        // participates in compositing — but since it's the LAST layer created
        // after the 2-frame flush, it paints on top.
        this.overlayElement.style.setProperty('-webkit-transform', 'translateZ(0)', 'important');
        this.overlayElement.style.setProperty('transform', 'translateZ(0)', 'important');
        this.isPortaledToBody = true;

        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
          this.setHeaderContainerZIndex('0');
        }

        // Start GSAP animations after portaling
        this.runGsapOpen();
      };

      // Double rAF: frame 1 = layout/style recalc, frame 2 = GPU composite flush
      requestAnimationFrame(() => requestAnimationFrame(doPortalAndAnimate));
      return; // GSAP starts inside doPortalAndAnimate
    }

    // Already portaled (re-open without close) — animate immediately
    this.runGsapOpen();
  }

  /** Runs the GSAP slide-in animation. Called after the overlay is in place. */
  private runGsapOpen() {
    if (!this.overlayElement || !this.panelElement) return;

    // Kill any existing animations on these elements
    gsap.killTweensOf([this.overlayElement, this.panelElement]);

    // Animate overlay fade in with autoAlpha (handles both opacity and visibility)
    gsap.to(this.overlayElement, {
      autoAlpha: 1,
      duration: 0.6,
      ease: 'power2.out'
    });

    // Animate panel slide in from right with fade using autoAlpha
    gsap.fromTo(this.panelElement,
      {
        x: '100%',
        autoAlpha: 0
      },
      {
        x: '0%',
        autoAlpha: 1,
        duration: 0.8,
        ease: 'power3.out',
        onComplete: () => {
          this.isAnimating = false;
        }
      }
    );
  }

  private animateClose() {
    if (!this.overlayElement || !this.panelElement) return;

    this.isAnimating = true;

    // Kill any existing animations on these elements
    gsap.killTweensOf([this.overlayElement, this.panelElement]);

    // Animate overlay fade out with autoAlpha (handles both opacity and visibility)
    gsap.to(this.overlayElement, {
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power2.in'
    });

    // Animate panel slide out to right with fade using autoAlpha
    gsap.to(this.panelElement, {
      x: '100%',
      autoAlpha: 0,
      duration: 0.6,
      ease: 'power3.in',
      onComplete: () => {
        this.isAnimating = false;
        // Move overlay back from body to host element
        this.returnOverlayFromBody();
      }
    });
  }

  /** Moves the overlay element back from document.body to the host element. */
  private returnOverlayFromBody(): void {
    if (this.useBodyPortal && this.isPortaledToBody && this.overlayElement) {
      // Remove the iOS z-index and translateZ overrides before moving back to component scope
      this.overlayElement.style.removeProperty('z-index');
      this.overlayElement.style.removeProperty('-webkit-transform');
      this.overlayElement.style.removeProperty('transform');
      this.elementRef.nativeElement.appendChild(this.overlayElement);
      this.isPortaledToBody = false;

      // Restore all GPU layer styles overridden by iosNeutralizeGpuLayers()
      this.iosRestoreGpuLayers();

      // Restore header z-index: remove inline overrides so CSS rules take over again
      if (typeof document !== 'undefined') {
        document.querySelectorAll<HTMLElement>('.header-container').forEach(el => {
          el.style.removeProperty('z-index');
        });
      }
    }
  }
} 
